import { getAuthAxiosBackend } from "@/helpers/axios"

class personTypesServices {
    get(id) {
        return getAuthAxiosBackend().get('person-types/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('person-types', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('person-types', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('person-types/' + id, data)
    }

    // restore(id, data) {
    //     return getAuthAxiosBackend().put('person-types/restore/' + id, data)
    // }

    delete(id) {
        return getAuthAxiosBackend().delete('person-types/softDelete/' + id.toString())
    }

    // forceDelete(id) {
    //     return getAuthAxiosBackend().delete('person-types/delete/' + id.toString())
    // }
}

export default new personTypesServices()